<template>
    <h2
        class="page__headline kb-inline-title"
        :class="{'kb-inline-title--disabled': disabled}"
    >
        <kb-dot v-if="hasDraft" size="lg" :title="$t('knowledgebase.unpublishedChanges')" />
        <input
            v-if="editing"
            ref="input"
            v-model="draft"
            class="kb-inline-title__input"
            :placeholder="placeholder"
            @blur="commit"
            @keydown.enter.prevent="commit"
            @keydown.escape="cancel"
        />
        <span v-else class="kb-inline-title__display" @click="startEdit">
            {{ value || placeholder }}
        </span>
        <kb-revert v-if="canRevert && !editing" @click="$emit('revert')" />
    </h2>
</template>

<script>
import KbDot from './kb-dot.vue';
import KbRevert from './kb-revert.vue';

export default {
    name: 'kb-inline-title',

    components: {KbDot, KbRevert},

    props: {
        value: {type: String, default: ''},
        placeholder: {type: String, default: ''},
        hasDraft: {type: Boolean, default: false},
        canRevert: {type: Boolean, default: false},
        disabled: {type: Boolean, default: false},
    },

    data() {
        return {
            editing: false,
            draft: '',
        };
    },

    methods: {
        startEdit() {
            if(this.disabled) return;
            this.draft = this.value || '';
            this.editing = true;
            this.$nextTick(() => {
                if(this.$refs.input) {
                    this.$refs.input.focus();
                    this.$refs.input.select();
                }
            });
        },
        cancel() {
            this.editing = false;
            this.draft = '';
        },
        commit() {
            if(!this.editing) return;
            const next = this.draft.trim();
            const current = this.value || '';
            this.editing = false;
            if(!next || next === current) return;
            this.$emit('save', next);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../variables';

.kb-inline-title {
    display: flex;
    align-items: baseline;
    gap: 8px;

    &__display {
        cursor: text;
        border-bottom: 1px dashed transparent;

        &:hover {
            border-bottom-color: #ddd;
        }
    }

    &__input {
        font-size: inherit;
        font-weight: inherit;
        color: inherit;
        background: transparent;
        border: 0;
        border-bottom: 2px solid $mc-primary;
        padding: 0 0 2px;
        outline: none;
        flex: 1;
        max-width: 600px;
    }

    &--disabled {
        @include kb-pending-deletion('.kb-inline-title__display');

        .kb-inline-title__display {
            cursor: default;
            pointer-events: none;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/pages/knowledge-base/kb-inline-title.vue